// extracted by mini-css-extract-plugin
module.exports = {"Mh200H5":"Mh200H5_Mh200H5__YAKsQ"};